import React, {useState} from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {Box, Flex, Text} from 'rebass'

import moment from 'moment'

import Calendar from 'react-calendar/dist/entry.nostyle'
import {CalenderWrapper} from "../../components/Base";

const Wrapper = styled(Box)`
	max-width: 400px;
`

const DatePicker = ({handleChange, name}) => {
	const [date, changeDate] = useState( new Date())
	const [showDate, changeShowDate] = useState(false)
	const handleDateChange = (date) => {
		changeDate(date)
		changeShowDate(true)
		const timeStamp = moment(date).unix();
		handleChange(timeStamp,name)
	}
	return (
		<Wrapper>

			<CalenderWrapper bg={'#263039'} color={'white'} width={1}>
				{showDate ?
					<Calendar
						onChange={handleDateChange}
						value={date}
					/> :
					<Calendar
						onChange={handleDateChange}
					/>
				}
			</CalenderWrapper>
			<Flex justifyContent={'center'} flexWrap={'wrap'}>
				{showDate &&
				<Text>{date.toDateString()}</Text>
				}
			</Flex>
		</Wrapper>
	);
};

DatePicker.propTypes = {
	handleChange: PropTypes.func,
	name: PropTypes.string
};

DatePicker.defaultProps = {
	handleChange: (date, name) => console.log(date, name),
	name: 'date-input'
};

export default DatePicker;
